export const CDN_URL = 'https://d3m1fwcc59lqhy.cloudfront.net';
